import React, { useCallback, useState } from "react";
import { useQueryClient } from "react-query";


const defautQueryKeyBuilder = (...args) => args; 
const defaultOptions = {}

function useFetchQuery(
    fetchQueryFn, 
    queryKeyBuilder = defautQueryKeyBuilder, 
    options = defaultOptions,
) {
    const queryClient = useQueryClient();

    const [isFetching, setIsFetching] = useState(false);

    const handleFetch = useCallback(async (context, args) => {
        try {
            setIsFetching(true);
            const result = await fetchQueryFn(context, args);
            options.onSuccess && options.onSuccess(result, context, args);
            setIsFetching(false);
            return result;
        } catch (error) {
            setIsFetching(false);
            options.onError && options.onError(error, context, args);
            throw error;
        }
    }, [options.onError, options.onSuccess]);

    const fetch = useCallback((...args) => {
        return queryClient.fetchQuery({
            ...options,
            queryKey: queryKeyBuilder(...args),
            queryFn: (context) => handleFetch(context, args),
        });
    }, [queryClient, queryKeyBuilder, options, handleFetch]);

    return {
        isFetching,
        fetch,
    };
}

export default useFetchQuery;


// WEBPACK FOOTER //
// ./src/hooks/useFetchQuery.js